"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var ConditionalHelper_1 = require("../../helpers/ConditionalHelper");
var ConditionalTransform = /** @class */ (function (_super) {
    __extends(ConditionalTransform, _super);
    function ConditionalTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConditionalTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var conditional = this.options.conditional;
        var conditionalHelper = new ConditionalHelper_1.ConditionalHelper(conditional, this.translationHelper);
        return conditionalHelper.matchesWithOptions({
            executionOptions: executionOptions,
            instance: queryResponse,
        });
    };
    return ConditionalTransform;
}(BaseTransform_1.BaseTransform));
exports.ConditionalTransform = ConditionalTransform;
//# sourceMappingURL=ConditionalTransform.js.map